import Retailer from '@/utilities/retailerHelper.js'

export default function retailerConsumerGoodsBlocker(to, _, next) {
  const isConsumerGoods = Retailer.isConsumerGoods()

  if (isConsumerGoods === false) {
    next()
    return
  }

  // Consumer goods retailer - check if route is allowed
  if (Retailer.canAccessRouteMeta(to.meta)) {
    next()
    return
  }

  // Route not allowed for consumer goods retailers
  next({
    name: 'retailer.dashboard'
  })
}
